<template>
  <div :class="{'container-dark': theme_dark}">
    <div class="nav-top">
      <div class="nav-left" @click="back()">
        <img src="../../assets/img/返回箭头.png" class="nav-img" />
        <span class="nav-lable"></span>
      </div>
      <div class="nav-middle">认证中心</div>
      <div class="nav-right">
        <span class="nav-lable"></span>
        <img src class="nav-img none" />
      </div>
    </div>
    <ul class="menu-block">
      <li class="ub ub-pc menu-item" @click="goto_wechat()">
        <div class="ub-ae ub-f1 menu-item-name">微信认证</div>
        <div class="ub ub-pc ub-ac">
            <div v-if="!rz_wx" class="state">未认证</div>
            <div v-if="rz_wx" class="state state-color">已认证</div>
          <img src="../../assets/img/箭头.png" class="menu-right-icon" />
        </div>
      </li>
      <div class="menu-line"></div>
      <li class="ub ub-pc menu-item" @click="bindTel()">
        <div class="ub-ae ub-f1 menu-item-name">手机号码认证</div>

        <div class="ub ub-pc ub-ac">
          <div v-if="!rz_tel" class="state">未认证</div>
          <div v-if="rz_tel" class="state state-color">已认证</div>
          <img src="../../assets/img/箭头.png" class="menu-right-icon" />
        </div>

      </li>
      <div class="menu-line"></div>
      <li class="ub ub-pc menu-item" @click="goto_myinfo()">
        <div class="ub-ae ub-f1 menu-item-name">个人资料认证</div>
        <div class="ub ub-pc ub-ac">
            <div v-if="!rz_info" class="state">未认证</div>
            <div v-if="rz_info" class="state state-color">已认证</div>
          <img src="../../assets/img/箭头.png" class="menu-right-icon" />
        </div>
      </li>
    </ul>

    <bindtel ref="myBindTel"></bindtel>
   
  </div>
</template>

<script>
  import { setTimeout } from "timers";
  import Bind from "../../components/BindTel.vue";
  import { mapMutations, mapActions } from "vuex";
  import * as tool from "../../api/common";
  export default {
    components: {
      bindtel: Bind
    },

    data() {
      return {
        rz_tel:false,
        rz_wx:false,
        rz_info:false,
        theme_dark: false
      };
    },
    mounted() {
      //切换深色模式
      this.theme_dark = tool.is_theme_dark(this);
      this.init_page();
    },
    methods: {
      ...mapActions(["act_get_userinfo"]), //引入方法
      back() {
        this.$router.go(-1); //返回上一层
      },
      goto_wechat() {
        this.$router.push({ name: "wechat" });
      },
      init_page() {
        var uid = this.$store.state.uid;
        var self = this;

        self.act_get_userinfo({
          uid: uid,
          success: function (u) {
            var sext = u.sex;
            var loc_province = u.loc_province;
            var loc_city = u.loc_city;
            var loc_area = u.loc_area;
            var inst_tag = u.inst_tag;

            var wx = u.wx;
            var tel = u.tel;

            if(tel){
              self.rz_tel = true;
            }
            if(wx){
              self.rz_wx = true;
            }
            if(loc_province && loc_city && loc_area && inst_tag){
              self.rz_info = true;
            }
          }
        });

      },

      bindTel() {
        var h =
          '<div style="font-size: 1em;line-height: 1.6em;color: #888;">完成手机号码认证，有助于提升你在系统中的信任度，有助于你获取更大的收益。</div>';
        this.$refs.myBindTel.show(h, {
          type: "alert",
          confirmText: "立即认证",
          titleText: "手机号码认证",
          data: ""
        });
      },
      goto_myinfo() {
        this.$router.push({ name: "my_info", params: { tag: "rz" } });
      }
    }
  };
</script>

<style lang="scss" scoped>
  .menu-block {
    padding: 0 0.8rem;
    background-color: #fff;
    .menu-item {
      height: 3rem;
      .menu-item-name{
        font-size: .95rem;
      }
      .state {
        margin-right: .3rem;
        font-size: .95rem;
        color: #9e9e9e;
      }

      .state-color {
        font-size: .95rem;
        color: #03fd20;
      }
      .menu-right-icon {
        width: 1.5rem;
        height: 1.5rem;
      }
    }
    .menu-line {
      border-top: 1px solid #EFEFEF;
    }
  }

  .container-dark {
    min-height: 100vh;
    background-color: #2f2e33;
    .menu-block {
      background-color: #2c2b30;
      .menu-item {
        .menu-item-name {
          color: #DFDFDF;
        }
      }
    }
    .menu-line {
      border-top: 1px solid #404040;
    }
  }
</style>